import { useAuth } from '@/features/Auth/state/AuthContext';
import { UserRole } from '../types/user-role';

/**
 * Hook para verificar se o usuário atual tem a role 'superadmin'
 * @returns Objeto com isSuperAdmin (boolean) e isLoading (boolean)
 */
export const useIsSuperAdminRole = () => {
  const { user, loading } = useAuth();

  const isSuperAdmin = !!user?.role && user.role.toLowerCase() === UserRole.SUPERADMIN;

  return { isSuperAdmin, isLoading: loading };
};

/** @deprecated Use useIsSuperAdminRole instead */
export const useIsSystemRole = useIsSuperAdminRole;
